export const emDash = "–";
